export const NoSubscriptionGraphic = () => {
  return (
    <svg width="109" height="108" viewBox="0 0 109 108" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect x="0.5" width="108" height="108" fill="white" fill-opacity="0.01" />
      <rect
        x="36.6072"
        y="17.34"
        width="60"
        height="72"
        rx="3"
        transform="rotate(10 36.6072 17.34)"
        fill="url(#paint0_linear_1744_6316)"
      />
      <rect
        x="30.7517"
        y="16.7223"
        width="60"
        height="72"
        rx="3"
        transform="rotate(5 30.7517 16.7223)"
        fill="url(#paint1_linear_1744_6316)"
      />
      <rect
        x="24.5"
        y="16.8"
        width="60"
        height="72"
        rx="3"
        fill="white"
        stroke="#E2E8F0"
        strokeWidth="1.01887"
        strokeLinecap="square"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M62.9 44.4C62.9 45.0628 62.3627 45.6 61.7 45.6C61.0373 45.6 60.5 45.0628 60.5 44.4C60.5 43.7373 61.0373 43.2 61.7 43.2C62.3627 43.2 62.9 43.7373 62.9 44.4ZM47.9 45.6C48.5627 45.6 49.1 45.0628 49.1 44.4C49.1 43.7373 48.5627 43.2 47.9 43.2C47.2372 43.2 46.7 43.7373 46.7 44.4C46.7 45.0628 47.2372 45.6 47.9 45.6ZM50.8099 49.1778C51.8204 50.3847 53.1742 51 54.8 51C56.4259 51 57.7797 50.3847 58.7901 49.1778C59.1092 48.7966 59.0589 48.229 58.6778 47.9099C58.2966 47.5909 57.729 47.6411 57.4099 48.0223C56.7459 48.8154 55.8997 49.2 54.8 49.2C53.7003 49.2 52.8541 48.8154 52.1901 48.0223C51.871 47.6411 51.3034 47.5909 50.9223 47.9099C50.5412 48.229 50.4909 48.7966 50.8099 49.1778Z"
        fill="#195DEE"
      />
      <defs>
        <linearGradient
          id="paint0_linear_1744_6316"
          x1="36.6072"
          y1="17.34"
          x2="36.6072"
          y2="89.34"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#0045D7" />
          <stop offset="1" stopColor="#195DEE" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_1744_6316"
          x1="0.751706"
          y1="52.7223"
          x2="71.5714"
          y2="111.739"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#98B9FF" />
          <stop offset="1" stopColor="#195DEE" />
        </linearGradient>
      </defs>
    </svg>
  )
}
